import React from 'react';
import axios from 'axios';
import config from '../config/config';
import url from 'url';
import { AppContext } from '../context/AppContext';
//import { Redirect } from "react-router-dom";

const hasData = (WrappedComponent) => {
    class hasDataHOC extends React.Component {

        service;

        constructor(props) {
            super(props);

            // https://github.com/axios/axios#creating-an-instance
            // `responseType` indicates the type of data that the server will respond with
            // options are: 'arraybuffer', 'document', 'json', 'text', 'stream'
            //   browser only: 'blob'
            // responseType: 'json', // default

            // The above comments are from the github web site, but I still set responseType: "application/json", even though I get the warning below
            // "The provided value 'application/json' is not a valid enum value of type XMLHttpRequestResponseType."
            // because in this case I can get error message properly from error.response.data, otherwise it is null (if responseType is 'json').
            // - Victor
            this.service = axios.create({
                baseURL: config.apiBaseUrl,
                responseType: "application/json"
            });

            this.service.interceptors.response.use(this.handleSuccess, this.handleError);
        }

        // interceptors
        handleSuccess = (response) => {
            //this.context.unmarkLoading(endpoint);

            this.context.unmarkLoading();
            this.setState({
                hasError: false,
                loading: false
            });

            return response;
        }

        handleError = (error) => {
            //this.context.unmarkLoading(endpoint);

            this.context.unmarkLoading();

            let unauthorized = false;

            if (!error.response || error.response.status === 401) {
                unauthorized = true;
            }

            this.setState({
                hasError: true,
                unauthorized: unauthorized,
                loading: false
            });

            return Promise.reject(error);
        }

        state = {
            data: [],
            loading: false,
            loadingMessage: "",
            hasError: false,
            unauthorized: false // set to true if http status code ever comes back with 401
        }

        getData = (endpoint, params = {}) => {

            let endpointUrl = url.parse(endpoint);

            // append random number to the endpoint url to bust out of caching
            if (endpointUrl.search !== null) {
                endpointUrl = endpointUrl.href + "&rand=" + Date.now().toString()
            } else {
                endpointUrl = endpointUrl.href + "?rand=" + Date.now().toString();
            }


            console.log('making a call to ', endpointUrl);
            //const token = this.context.state.token;
            const token = this.context.state.accessToken;

            this.service.defaults.headers.common['authorization'] = `Bearer ${token}`;

            this.setState({ loading: true });

            this.context.markLoading();


            //return this.service.get(endpoint, { ...params });
            return this.service.get(endpointUrl, { ...params });

        }

        postData = (endpoint, params = {}) => {

            console.log('posting to ', endpoint)
            //const token = this.context.state.token;
            const token = this.context.state.accessToken;
            this.service.defaults.headers.common['authorization'] = `Bearer ${token}`;

            this.setState({ loading: true });

            // make a note that we're loading data for this endpoint
            this.context.markLoading();



            return this.service.post(endpoint, params);

        }
        deleteData = (endpoint, params = {}) => {
            console.log('deleting to ', endpoint)
            //const token = this.context.state.token;
            const token = this.context.state.accessToken;

            this.service.defaults.headers.common['authorization'] = `Bearer ${token}`;

            this.setState({ loading: true });

            this.context.markLoading();
            return this.service.delete(endpoint, { ...params });
        }

        render() {
            if (this.state.unauthorized) {
                // temporarily commented out, until all endpoints are converted to Auth0
                //return <Redirect to="/?session-expired=1" />;
            }

            return (

                <React.Fragment>

                    <WrappedComponent
                        getData={this.getData}
                        postData={this.postData}
                        deleteData={this.deleteData}
                        {...this.state}
                        {...this.props} />

                </React.Fragment>
            );
        }
    }

    hasDataHOC.contextType = AppContext;

    return hasDataHOC;
}

export default hasData;


// WEBPACK FOOTER //
// ./src/hoc/hasData.js